import _styled from "styled-components";
const _excluded = ["style", "className", "disabled", "children", "active", "renderIcon", "onClick"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import TypographyWidthHolder from './TypographyWidthHolder';
/**
 * Tab title - the clickable item used to switch between tabs.
 */
const TabTitle = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      style,
      className,
      disabled,
      children,
      active,
      renderIcon,
      onClick
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const labelAndIcon = children && renderIcon;
  return /*#__PURE__*/React.createElement(_StyledButton, _extends({}, props, {
    ref: ref,
    className: className,
    disabled: disabled,
    type: "button",
    role: "tab",
    onClick: onClick,
    $_css: [_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      position: 'relative',
      display: 'flex',
      justifyContent: labelAndIcon ? 'space-between' : 'center',
      alignItems: 'center',
      margin: `0 ${theme.spacing.S}px`,
      textDecoration: 'none',
      minWidth: 48,
      '&:first-child': {
        marginLeft: 0
      },
      '&:last-child': {
        marginRight: 0
      },
      '&::-moz-focus-inner': {
        border: 0
      },
      background: 'none',
      outline: 'none',
      border: 'none',
      cursor: 'pointer',
      padding: `0 ${theme.spacing.XXS}px 6px`,
      color: theme.tokens.colors.text.primary.value
    }, theme.typography.heading4), {}, {
      '&:focus': {
        '&:before': {
          content: "' '",
          position: 'absolute',
          bottom: '-3px',
          right: 0,
          left: 0,
          borderBottom: `2px solid ${theme.colors.focusHalo}`
        }
      },
      '&:active': _objectSpread({}, !disabled && theme.typography.heading4),
      '&:active:focus': {
        '&:before': {
          borderBottom: 0
        }
      }
    }, !disabled && {
      '&:hover': {
        color: theme.tokens.colors.text.hover.value
      }
    }), active && {
      color: theme.tokens.colors.text.primary.value
    }), !active && {
      fontWeight: 500
    }), !active && disabled && {
      color: theme.tokens.colors.text.inactive.value,
      cursor: 'default'
    }), style]
  }), renderIcon === null || renderIcon === void 0 ? void 0 : renderIcon({
    style: _objectSpread(_objectSpread({}, children && {
      marginRight: theme.spacing.XS
    }), disabled && {
      color: theme.tokens.colors.icon.inactive.value
    })
  }), /*#__PURE__*/React.createElement(TypographyWidthHolder, {
    typographyStyle: theme.typography.heading4
  }, children));
});
TabTitle.displayName = 'TabTitle';
TabTitle.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** whether this tab is disables */
  disabled: PropTypes.bool,
  /** whether this tab is currently active */
  active: PropTypes.bool,
  /** The content of the tab title */
  children: PropTypes.any,
  /** Render the icon */
  renderIcon: PropTypes.func,
  /** Handles title click */
  onClick: PropTypes.func
};
export default TabTitle;
var _StyledButton = _styled("button").withConfig({
  displayName: "TabTitle___StyledButton",
  componentId: "sc-3fwuoz-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=TabTitle.js.map